import { render, staticRenderFns } from "./InvoiceAddress.vue?vue&type=template&id=0bc59674&scoped=true&"
import script from "./InvoiceAddress.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddress.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAddress.vue?vue&type=style&index=0&id=0bc59674&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc59674",
  null
  
)

export default component.exports